export default function PageHeader({ eyebrow, title, subtitle, actions, testid }) {
  return (
    <div className="border-b border-[#E5E0D5] px-4 sm:px-6 lg:px-8 py-5 sm:py-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between" data-testid={testid}>
      <div>
        {eyebrow && <div className="uppercase-label mb-2">{eyebrow}</div>}
        <h1 className="text-2xl md:text-3xl font-medium tracking-tight text-[#0F0F0F]">{title}</h1>
        {subtitle && <p className="text-sm text-[#5A5A5A] mt-1 max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}
